import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '@fabric-app/ui/components/Button';
import { useContextAccessToken } from '../contexts/AnonShareTokenContext.js';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import { IconNavigational24AddPeople } from '@fabric-app/icons/svg';

const ButtonShare = ({ disabledReason, text, ...props }) => {
  const accessToken = useContextAccessToken();
  if (accessToken) {
    return null;
  }
  const mainEl = /* @__PURE__ */ jsxs(Button, {
    shape: "square",
    variant: "primary-inverse",
    "data-testid": "space-view-share-button",
    ...props,
    disabled: !!disabledReason || props.disabled,
    children: [
      /* @__PURE__ */ jsx(IconNavigational24AddPeople, {}),
      " ",
      text
    ]
  });
  if (disabledReason) {
    return /* @__PURE__ */ jsx(Tooltip, {
      delay: 0,
      label: disabledReason,
      children: mainEl
    });
  }
  return mainEl;
};

export { ButtonShare };
//# sourceMappingURL=ButtonShare.js.map
